// Laqy Consumer Web — API Configuration
// Consumer-only endpoints. No admin/broker routes exposed.

export const API_BASE_URL = import.meta.env.VITE_API_URL || '';
export const GOOGLE_MAPS_KEY = import.meta.env.VITE_GOOGLE_MAPS_API_KEY || '';
export const MAPBOX_TOKEN = import.meta.env.VITE_MAPBOX_TOKEN || 'pk.eyJ1IjoiZGlzY29oYXJhbSIsImEiOiJjbWszZjBxdnUwNWhlM2ZzYnVxMjg2M2xwIn0.FLuerhOuw_PHiIjvSiIfjw';

export const ENDPOINTS = {
  // Auth
  LOGIN: '/api/v1/token',
  REGISTER: '/api/v1/users/register',
  GET_ME: '/api/v1/users/me',
  VERIFY_EMAIL: '/api/v1/verify-email',
  REQUEST_PASSWORD_RESET: '/api/v1/request-password-reset',
  RESET_PASSWORD: '/api/v1/reset-password',
  RESEND_VERIFICATION: '/api/v1/resend-verification-email',

  // Public Data
  PROPERTIES: '/api/v1/properties/',
  AREAS: '/api/v1/areas/',
  DEVELOPERS: '/api/v1/developers/',
  COMPOUNDS: '/api/v1/compounds/',
  INQUIRIES: '/api/v1/inquiries',
  LEADS: '/api/v1/leads/track',

  // Consumer Actions
  FAVORITES: '/api/v1/users/me/favorites',
  SAVED_SEARCHES: '/api/v1/users/me/searches',

  // Media
  UPLOAD: '/api/v1/media/upload',

  // Masterplans (read-only for map views)
  MASTERPLANS: '/api/v1/masterplans/',

  // GenAI
  GENAI_RENDER: '/api/v1/genai/generate-render',
};
